import { Button, Typography } from "@suraasa/placebo-ui"
import { OfferLetterType } from "api/resources/offerLetter/types"
import clsx from "clsx"
import { getProductImage } from "features/LearningItems/getProductDisplayConfig"
import { Lock } from "iconoir-react"
import { Link } from "react-router-dom"
import routes from "routes"

import { usePgCTLOfferLetter } from "../usePgCTLOfferLetter"

const Banner = ({
  offerLetter,
  openOfferLetter,
}: {
  offerLetter: OfferLetterType
  openOfferLetter: () => void
}) => {
  const { deliveryModeBadge: badge, isRegistrationDone } = usePgCTLOfferLetter()

  return (
    <div className="mb-4 overflow-hidden rounded-2xl border border-surface-200">
      <div className="p-2.5 sm:p-3">
        <div className="mb-4 flex flex-col-reverse items-start justify-between gap-1 sm:flex-row">
          <div className="flex max-w-[339px] flex-col gap-1 sm:gap-1.5">
            <Typography
              variant="preTitle"
              className="!tracking-normal text-onSurface-500"
            >
              Qualification Offer Letter Issued
            </Typography>
            <Typography variant="title3">{offerLetter.product.name}</Typography>
            {badge && (
              <span
                className={clsx(
                  "w-fit rounded px-1 py-0.5 text-preTitle uppercase",
                  badge.bg,
                  badge.color
                )}
              >
                {badge.text}
              </span>
            )}
          </div>
          <img
            src={getProductImage({
              slug: offerLetter.product.slug,
              defaultImage: null,
            })}
            alt={offerLetter.product.slug}
            className="size-[73px] overflow-hidden rounded-xl"
          />
        </div>
        <div className="flex flex-col gap-1.25 sm:flex-row">
          {isRegistrationDone ? (
            <Button
              disabled
              className="w-full bg-onSurface-500 text-strong sm:w-fit"
              startAdornment={<Lock strokeWidth={2} />}
            >
              Start Learning
            </Button>
          ) : (
            <Link
              to={
                routes.pgctlOnboarding.payment +
                `?product=${offerLetter.product.slug}`
              }
            >
              <Button color="black" className="w-full text-strong sm:w-fit">
                Pay Registration Fee
              </Button>
            </Link>
          )}

          <Button
            onClick={openOfferLetter}
            className="w-full border border-onSurface-300 bg-white text-strong text-onSurface-700 sm:w-fit"
          >
            View Offer Letter
          </Button>
        </div>
      </div>
      {isRegistrationDone && (
        <div className="bg-highlight-50 p-2.5">
          <Typography className="mb-1 text-highlight-800" variant="strong">
            Complete Your Payment to Unlock PgCTL
          </Typography>
          <Typography className="text-onSurface-500" variant="smallBody">
            We’ve received your registration fee. To unlock all PgCTL benefits
            and begin learning, please complete your full payment. <br />
            <br />
            Your Admission Support Executive will reach out to guide you through
            the final admission formalities, including fee payment.
          </Typography>
        </div>
      )}
    </div>
  )
}

export default Banner
